<template>
  <div class="replenish">
    <progressBar
      class="replenish-progress"
      :arr="progressData"
      :activeIndex="progressActiveIndex"></progressBar>
    <tips class="replenish-tip">
      <div class="replenish-tip__line"> 1.由于“采购单”由“采购计划单”中的“FBA发补货计划单”单独生成或合并生成，因此如要删除“采购单”需先到“销售/FBA发补货计划单”或/及“销售/产品储备计划单”目录，先删除该“采购单”对应的“FBA发补货计划单”或/及“产品储备计划单”； </div>
      <div class="replenish-tip__line"> 2.这里的采购单需要采购人员对其进行补充采购价格，货物送仓地址，支付条款，要求交货日期等信息（如需签订采购合同，也可下载采购合同，整理好采购合同后发送给供应商，并将供应商回传的采购合同上传保存以作日后查询）； </div>
      <div class="replenish-tip__line"> 3.通常根据采购合同签定及采购款到帐为采购生效，但由于考虑不同企业采购确认的处理方式不一样，本系统提供弹性处理，采购人员可根据实际情况，在补充弹窗中可点击“采购已生效”来确认采购生效状态。 </div>
    </tips>
    <div class="replenish-top">
      <div class="replenish-top__name">待补充采购计划单</div>
      <div class="replenish-top__fun">
        <div class="replenish-top-item replenish-top-item--date">
          <div class="replenish-top-item__name">创建日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="replenish-top-item replenish-top-item--date">
          <div class="replenish-top-item__name">要求交货日期:</div>
          <el-date-picker
            size="mini"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </div>
        <div class="replenish-top-item">
          <div class="replenish-top-item__name">支付状况:</div>
          <el-select size="mini"></el-select>
        </div>
        <div class="replenish-top-item replenish-top-item--input">
          <el-input size="mini" placeholder="请输入采购单号/供应商"></el-input>
        </div>
        <div class="replenish-top__btn">搜索</div>
      </div>
    </div>
    <div class="replenish-table">
      <Table height="550" width="1654" :head="replenishTableHead"></Table>
    </div>
  </div>
</template>

<script>
import { PurchaseNewModule } from './class'
import progressBar from 'components/common/progressBar';
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
export default {
  name: 'purchaseOrderToBeSupplemented',
  components: {
    progressBar, tips, Table
  },
  data(){
    return {
      /**进度条数据 */
      progressData: PurchaseNewModule.NEWPROGRESSARRAY(),
      progressActiveIndex: 2,
      replenishTableHead: PurchaseNewModule.NEWREPLENISHTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.replenish{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__fun{
      display: flex;
    }
    &-item{
      display: flex;
      align-items: center;
      margin-left: 10px;
      ::v-deep{
        .el-input__inner{
          width: 100px;
        }
      }
      &__name{
        font-size: 14px;
        margin-right: 5px;
      }
      &--date{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
      &--input{
        ::v-deep{
          .el-input__inner{
            width: 180px;
          }
        }
      }
    }
    &__btn{
      line-height: 30px;
      padding: 0 15px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
